import styled from 'styled-components';

const NesAction = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;

  button {
    margin-left: 10px;
  }

  p {
    flex-grow: 1;
  }
`;

export default NesAction;
